import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-113894d6")

_pushScopeId("data-v-113894d6")
const _hoisted_1 = { class: "dialog__content" }
const _hoisted_2 = { class: "dialog__list scrollbar--invisible" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-info-circled" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.notificationsVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: false,
            tabindex: "0",
            onClose: _ctx.closeDialog,
            onKeydown: _withKeys(_ctx.closeDialog, ["esc"])
          }, {
            body: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notifications, (notf) => {
                    return (_openBlock(), _createBlock("div", {
                      key: notf._id,
                      class: "dialog__item"
                    }, [
                      _hoisted_3,
                      _createVNode("div", null, _toDisplayString(notf.description), 1),
                      _createVNode("i", {
                        class: "icon-cancel-circled",
                        onClick: ($event: any) => (_ctx.notificationVisited(notf._id))
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onKeydown"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})